export default "__VITE_ASSET__CagYk35U__"